/* eslint-disable react/no-multi-comp */
/* eslint-disable react/no-danger */
import React from "react"
import Img from "gatsby-image/withIEPolyfill"
import { useInView } from "react-intersection-observer"
import { Link } from "gatsby"

import { Headline, GridLines, PageCircles, Analytics } from "@shared"
import { css, randomInt, joinNewLines } from "@jsUtils"
import { URLS, CONTENT, CONSTANTS } from "@data"

import { PageSection } from "../PageSection"

import Styles from "./ourPeopleFeature.module.scss"

const TrackLink = Analytics(Link)

const PersonCard = props => {
  const { person } = props
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true
  })
  return (
    <TrackLink
      ascope="CTAS"
      adata="MISC.PEOPLE"
      to={`${URLS.LEADERSHIP}${person.slug}/`}
      className={css(Styles.personWrapper, inView && Styles.personReady)}
      key={person.slug}
    >
      <div ref={ref} className={Styles.person}>
        <div className={Styles.portraitWrapper}>
          <Img alt={person.photo.title} className={Styles.portrait} fluid={person.photo.fluid} />
        </div>
      </div>
      <Headline size={5} className={Styles.name}>
        {person.name}
      </Headline>
      <p className={Styles.title}>{person.title}</p>
    </TrackLink>
  )
}

const Quote = props => {
  const { children } = props
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true
  })
  return (
    <div className={css(Styles.quoteWrapper, inView && Styles.quoteReady)} ref={ref}>
      <Headline className={Styles.quote} size={4}>
        {children}
      </Headline>
    </div>
  )
}

const TeamGrid = props => {
  const { team } = props
  const people = team.people.map(person => {
    const keyId = randomInt(0, Date.now())
    return person.content ? (
      <Quote key={keyId}>{person.content}</Quote>
    ) : (
      <PersonCard key={keyId} person={person} />
    )
  })
  return (
    <div className={Styles.team}>
      <span className={Styles.teamTitle}>{team.title}</span>
      {people}
    </div>
  )
}

/**
 * Our People Feature Section
 * @param {object} props - React props
 */
const OurPeopleFeature = props => {
  const { color, theme, teams } = props
  const [ready, setReady] = React.useState(false)
  const grids = teams.map(team => {
    const keyId = randomInt(0, Date.now())
    return <TeamGrid team={team} color={color} ready={ready} key={keyId} />
  })
  return (
    <PageSection
      className={css(Styles.section, Styles[`theme_${theme}`], ready && Styles.ready)}
      theme={theme}
      ready={ready}
      id={CONTENT.BIO.BACK_LINK_TARGET}
      onReady={() => {
        setReady(true)
      }}
    >
      <GridLines theme={theme} />
      <PageCircles
        relativeParent="-25vw"
        settings={{
          align: "left",
          color: CONSTANTS.COLORS.FLURO,
          fromTop: "auto",
          orbit: true,
          size: "medium"
        }}
      />
      <div className={Styles.wrapper}>
        <div className={Styles.header}>
          <Headline className={Styles.sectionTitle} size={2}>
            <span dangerouslySetInnerHTML={{ __html: joinNewLines(CONTENT.OUR_PEOPLE.FEATURED) }} />
          </Headline>
        </div>
        <PageCircles
          relativeParent="10vw"
          settings={{
            align: "right",
            color: CONSTANTS.COLORS.BLUE,
            fromTop: "auto",
            orbit: false,
            size: "small"
          }}
        />
        <div className={Styles.content}>{grids}</div>
      </div>
    </PageSection>
  )
}

export default OurPeopleFeature
